import "es6-shim";
import * as React from 'react';
import { LanguageCodes } from "../constants/languages";

const LogoEnSvg = require('../assets/images/logo-en.svg');
const LogoEsSvg = require('../assets/images/logo-es.svg');
const LogoFrSvg = require('../assets/images/logo-fr.svg');

interface IHeaderBannerProps {
    title?: string,
    locale?: LanguageCodes,
    largeLogoSize?: boolean,
    clinicSiteName?: string
}

export const HeaderBanner = (props: IHeaderBannerProps) => {
    const logoMap = {
        [LanguageCodes.English]: LogoEnSvg,
        [LanguageCodes.French]: LogoFrSvg,
        [LanguageCodes.Spanish]: LogoEsSvg
    };

    const renderMedfarLogo = (): JSX.Element => {
        const logoStyle = props.largeLogoSize ? "medfar-logo-big" : "medfar-logo-small";
        const logoPath = logoMap[props.locale] || LogoEnSvg;
        return <img className={logoStyle} src={logoPath} alt="MEDFAR SOLUTIONS"/>;
    }

    if (props.clinicSiteName) {
        return (
            <div className="row" style={{ marginTop: "30px" }}>
                <div className="col-md-12 text-center" style={{ padding: "20px" }}>
                    <h1>{props.clinicSiteName}</h1>
                </div>
            </div>
        );
    }
    if (props.title) {
        return (
            <div className="row" style={{ marginTop: "30px" }}>
                <div className="col-md-12 text-center" style={{ padding: "20px" }}>
                    {renderMedfarLogo()}
                    <span style={{ fontSize: "40px", fontWeight: "bold" }}>{props.title}</span>
                </div>
            </div>
        );
    }
    return (
        <div className="row" style={{ marginTop: "30px" }}>
            <div className="col-md-12 text-center">
                {renderMedfarLogo()}
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/HeaderBanner.tsx